export class SearchFiltersModel {
    public startDate: string;
    public endDate: string;

    public categories: Array<string> = [];
    public eventCategories: Array<string> = [];
    public needsOfChildren: Array<string> = [];
    public postcodes: Array<string> = [];
    public age: Array<string> = [];
    public frequency: Array<string> = [];
    public dietaryNeeds: Array<string> = [];
    public accessibility: Array<string> = [];
    public provisionTypes: Array<string> = [];
    public schoolNeeds: Array<string> = [];
    public specialDietCater: Array<string> = [];

    public postcode: string;
    public distance: string;
}
